"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toBase64 = exports.shstoreIdMappings = exports.setUserInfoFromRequestCookies = exports.isPrimaryEvent = exports.isFunction = exports.isDefined = exports.getUserInfoFromRequestCookies = exports.getCookieTTL = exports.USER_INFO_COOKIE_NAME = exports.TIME = exports.PRIMARY_EVENT_SOURCE_ID = exports.HTTP_CODES = exports.HELP_CENTER_LINKS = exports.FAN_PROTECT_LINKS = exports.DEFAULT_COOKIE_TTL_MULTIPLIER = void 0;
var shstoreIdMappings = {
  1: {
    title: 'US',
    site: 'US'
  },
  2: {
    title: 'UK',
    site: 'GB'
  },
  3: {
    title: 'DE',
    site: 'DE'
  },
  4: {
    title: 'FR',
    site: 'FR'
  },
  5: {
    title: 'MX',
    site: 'MX'
  },
  6: {
    title: 'SP',
    site: 'ES'
  },
  7: {
    title: 'PT',
    site: 'PT'
  },
  8: {
    title: 'CA',
    site: 'CA'
  },
  9: {
    title: 'CZ',
    site: 'CZ'
  },
  10: {
    title: 'IT',
    site: 'IT'
  },
  11: {
    title: 'NL',
    site: 'NL'
  },
  12: {
    title: 'AT',
    site: 'AT'
  },
  13: {
    title: 'BE',
    site: 'BE'
  },
  14: {
    title: 'IE',
    site: 'IE'
  },
  15: {
    title: 'FI',
    site: 'FI'
  },
  16: {
    title: 'LU',
    site: 'LU'
  },
  17: {
    title: 'GR',
    site: 'GR'
  },
  18: {
    title: 'PL',
    site: 'PL'
  },
  19: {
    title: 'SE',
    site: 'SE'
  },
  20: {
    title: 'DK',
    site: 'DK'
  },
  21: {
    title: 'AR',
    site: 'AR'
  },
  22: {
    title: 'JP',
    site: 'JP'
  },
  23: {
    title: 'KR',
    site: 'KR'
  },
  24: {
    title: 'BR',
    site: 'BR'
  },
  26: {
    title: 'TR',
    site: 'TR'
  },
  27: {
    title: 'TW',
    site: 'TW'
  },
  28: {
    title: 'HK',
    site: 'HK'
  }
};
exports.shstoreIdMappings = shstoreIdMappings;
var PRIMARY_EVENT_SOURCE_ID = '29001';
exports.PRIMARY_EVENT_SOURCE_ID = PRIMARY_EVENT_SOURCE_ID;
var isPrimaryEvent = function isPrimaryEvent(sourceId) {
  return (sourceId === null || sourceId === void 0 ? void 0 : sourceId.toString()) === PRIMARY_EVENT_SOURCE_ID;
};
exports.isPrimaryEvent = isPrimaryEvent;
var toBase64 = function toBase64(data) {
  if (typeof window !== 'undefined') {
    return window.btoa(encodeURIComponent(data));
  }
  return Buffer.from(encodeURIComponent(data)).toString('base64');
};
exports.toBase64 = toBase64;
var isDefined = function isDefined(param) {
  return typeof param !== 'undefined';
};
exports.isDefined = isDefined;
var HTTP_CODES = {
  // 1xx Informational responses
  CONTINUE: 100,
  SWITCHING_PROTOCOLS: 101,
  PROCESSING: 102,
  EARLY_HINTS: 103,
  // 2xx Success
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NON_AUTHORITATIVE_INFO: 203,
  // Original key
  NON_AUTHORITATIVE_INFORMATION: 203,
  // Added for consistency with the list
  NO_CONTENT: 204,
  RESET_CONTENT: 205,
  PARTIAL_CONTENT: 206,
  MULTI_STATUS: 207,
  // 3xx Redirection
  MULTIPLE_CHOICES: 300,
  PERMANTENTLY_MOVED_RESOURCE: 301,
  // Original key
  MOVED_PERMANENTLY: 301,
  // Added for consistency with the list
  FOUND: 302,
  // Original key
  MOVED_TEMPORARILY: 302,
  // Added for consistency with the list
  SEE_OTHER: 303,
  NOT_MODIFIED: 304,
  USE_PROXY: 305,
  TEMPORARY_REDIRECT: 307,
  PERMANENT_REDIRECT: 308,
  // 4xx Client errors
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  RESOURCE_NOT_FOUND: 404,
  // Original key
  NOT_FOUND: 404,
  // Added for consistency with the list
  METHOD_NOT_ALLOWED: 405,
  NOT_ACCEPTABLE: 406,
  PROXY_AUTHENTICATION_REQUIRED: 407,
  REQUEST_TIMEOUT: 408,
  CONFLICT: 409,
  GONE: 410,
  LENGTH_REQUIRED: 411,
  PRECONDITION_FAILED: 412,
  REQUEST_TOO_LONG: 413,
  REQUEST_URI_TOO_LONG: 414,
  UNSUPPORTED_MEDIA_TYPE: 415,
  REQUESTED_RANGE_NOT_SATISFIABLE: 416,
  EXPECTATION_FAILED: 417,
  IM_A_TEAPOT: 418,
  INSUFFICIENT_SPACE_ON_RESOURCE: 419,
  METHOD_FAILURE: 420,
  MISDIRECTED_REQUEST: 421,
  UNPROCESSABLE_ENTITY: 422,
  LOCKED: 423,
  FAILED_DEPENDENCY: 424,
  UPGRADE_REQUIRED: 426,
  PRECONDITION_REQUIRED: 428,
  TOO_MANY_REQUESTS: 429,
  REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
  UNAVAILABLE_FOR_LEGAL_REASONS: 451,
  // 5xx Server errors
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  HTTP_VERSION_NOT_SUPPORTED: 505,
  INSUFFICIENT_STORAGE: 507,
  NETWORK_AUTHENTICATION_REQUIRED: 511
};
exports.HTTP_CODES = HTTP_CODES;
var TIME = {
  MILLIS_OF_SECOND: 1000,
  SECONDS_OF_MIN: 60,
  MINS_OF_HOUR: 60,
  HOURS_OF_DAY: 24,
  DAYS_OF_YEAR: 365
};
exports.TIME = TIME;
var FAN_PROTECT_LINKS = Object.freeze({
  'en-us': 'https://support.stubhub.ie/en/support/solutions/articles/80000618889/',
  'en-gb': 'https://support.stubhub.co.uk/en/support/solutions/articles/80000618888/',
  'de-de': 'https://support.stubhub.de/de/support/solutions/articles/80000618889/',
  'fr-fr': 'https://support.stubhub.fr/fr/support/solutions/articles/80000618889/',
  'es-mx': 'https://support.stubhub.es/es/support/solutions/articles/80000618889/',
  'es-es': 'https://support.stubhub.es/es/support/solutions/articles/80000618889/',
  'pt-pt': 'https://support.stubhub.pt/pt-PT/support/solutions/articles/80000618889/',
  'en-ca': 'https://support.stubhub.ie/en/support/solutions/articles/80000618889/',
  'cs-cz': 'https://www.stubhub.cz/legal/?section=fp',
  'it-it': 'https://support.stubhub.it/it/support/solutions/articles/80000618889/',
  'nl-nl': 'https://www.stubhub.nl/legal/?section=fp',
  'de-at': 'https://support.stubhub.de/de/support/solutions/articles/80000618889/',
  'nl-be': 'https://www.stubhub.be/legal/?section=fp',
  'fr-be': 'https://support.stubhub.fr/fr/support/solutions/articles/80000618889/',
  'en-ie': 'https://support.stubhub.ie/en/support/solutions/articles/80000618889/',
  'fi-fi': 'https://support.stubhub.ie/en/support/solutions/articles/80000618889/',
  'de-lu': 'https://support.stubhub.de/de/support/solutions/articles/80000618889/',
  'fr-lu': 'https://support.stubhub.fr/fr/support/solutions/articles/80000618889/',
  'el-gr': 'https://support.stubhub.ie/en/support/solutions/articles/80000618889/',
  'pl-pl': 'https://www.stubhub.pl/legal/?section=fp',
  'sv-se': 'https://www.stubhub.se/legal/?section=fp',
  'da-dk': 'https://support.stubhub.ie/en/support/solutions/articles/80000618889/',
  "default": 'https://support.stubhub.ie/en/support/solutions/articles/80000618889/'
});
exports.FAN_PROTECT_LINKS = FAN_PROTECT_LINKS;
var HELP_CENTER_LINKS = Object.freeze({
  'en-us': 'https://support.stubhub.com/',
  'en-gb': 'https://support.stubhub.co.uk/',
  'de-de': 'https://support.stubhub.de/',
  'fr-fr': 'https://support.stubhub.fr/',
  'es-mx': 'https://support.stubhub.mx/',
  'es-es': 'https://support.stubhub.es/',
  'pt-pt': 'https://support.stubhub.pt/',
  'en-ca': 'https://support.stubhub.com/',
  'cs-cz': 'https://support.stubhub.cz/',
  'it-it': 'https://support.stubhub.it/',
  'nl-nl': 'https://support.stubhub.nl/',
  'de-at': 'https://support.stubhub.co.at/',
  'nl-be': 'https://support.stubhub.be/nl/',
  'fr-be': 'https://support.stubhub.be/fr/',
  'en-ie': 'https://support.stubhub.ie/',
  'fi-fi': 'https://support.stubhub.fi/',
  'de-lu': 'https://support.stubhub.lu/de/',
  'fr-lu': 'https://support.stubhub.lu/fr/',
  'el-gr': 'https://support.stubhub.gr/',
  'pl-pl': 'https://support.stubhub.pl/',
  'sv-se': 'https://support.stubhub.se/',
  'da-dk': 'https://support.stubhub.dk/',
  "default": 'https://support.stubhub.ie/'
});
exports.HELP_CENTER_LINKS = HELP_CENTER_LINKS;
var DEFAULT_COOKIE_TTL_MULTIPLIER = 21600000; // 6 hours in milliseconds
exports.DEFAULT_COOKIE_TTL_MULTIPLIER = DEFAULT_COOKIE_TTL_MULTIPLIER;
var USER_INFO_COOKIE_NAME = process.env.REACT_APP_USER_INFO_COOKIE_NAME;

/**
 * Generates the expiration date for a cookie based on a TTL (time-to-live) multiplier.
 *
 * @param {number} [ttlMultiplier=DEFAULT_COOKIE_TTL_MULTIPLIER] - The time-to-live multiplier in milliseconds.
 * @return {Date} The expiration date for the cookie.
 */
exports.USER_INFO_COOKIE_NAME = USER_INFO_COOKIE_NAME;
var getCookieTTL = function getCookieTTL() {
  var ttlMultiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_COOKIE_TTL_MULTIPLIER;
  var cookieTTL = new Date();
  cookieTTL.setTime(cookieTTL.getTime() + ttlMultiplier);
  return cookieTTL;
};

/**
 * Checks if the given instance is a function.
 *
 * @param {*} functionInstance - The instance to check.
 * @returns {boolean} True if the instance is a function, otherwise false.
 */
exports.getCookieTTL = getCookieTTL;
var isFunction = function isFunction(functionInstance) {
  return typeof functionInstance === 'function';
};

/**
 * Method to Return the User Info Object From Cookies
 * @TODO - Extract Into Separate Method when SH_USER_INFO Cookies are updated in multiple components.
 * @param cookies [object] CookieServer Or CookiesClient Instance to Write/Read Cookies Isomorphically.
 * @returns shUserInfoCookie [object] The User Info Cookie Object.
 *
 */
exports.isFunction = isFunction;
var getUserInfoFromRequestCookies = function getUserInfoFromRequestCookies(cookies) {
  return cookies && isFunction(cookies.getJSON) && cookies.getJSON(USER_INFO_COOKIE_NAME) || {};
};

/**
 * Method to Set the User Info Object from Cookies
 * @TODO - Extract Into Separate Method when SH_USER_INFO Cookies are updated in multiple components.
 * @param cookies [object] CookieServer Or CookiesClient Instance to Write/Read Cookies Isomorphically.
 * @param userInfoCookie [object] User Info Cookie Object Instance.
 * @returns shUserInfoCookie [object] The User Info Cookie Object.
 *
 */
exports.getUserInfoFromRequestCookies = getUserInfoFromRequestCookies;
var setUserInfoFromRequestCookies = function setUserInfoFromRequestCookies(cookies, userInfoCookie) {
  var expirationPeriod = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_COOKIE_TTL_MULTIPLIER;
  if (cookies && isFunction(cookies.setJSON)) {
    cookies.setJSON(USER_INFO_COOKIE_NAME, userInfoCookie, {
      expires: getCookieTTL(expirationPeriod)
    });
  }
};
exports.setUserInfoFromRequestCookies = setUserInfoFromRequestCookies;